import { Embed } from './embed';

export class RestaurantEmbed extends Embed {
  restaurantId: number;
}
